import request from '@/utils/request'
/**
 *
 * 客单管理
 *
 **/
// 登录
export const getClienteleList = (params: any) =>
  request({
    'url': '/clientele',
    'method': 'get',
    params
  })
export const queryClienteleById = (id: number) =>
  request({
    'url': `/clientele/${id}`,
    'method': 'get'
  })

export const addClientele = (params: any) =>
  request({
    'url': '/clientele',
    'method': 'POST',
    'data': params
  })

export const deleteClientele = (id: number) =>
  request({
    'url': `/clientele/${id}`,
    'method': 'DELETE',
  })

// 修改客单
export const updateClientele = (params: any) =>
  request({
    'url': '/clientele',
    'method': 'PUT',
    'data': params
  })

export const getConvertedScore = (id: number) =>
  request({
    'url': `/clientele/getConvertedScore/${id}`,
    'method': 'GET',
  })

export const getMajorTypesAndSchools = () =>
  request({
    'url': `/clientele/getMajorTypesAndSchools`,
    'method': 'GET',
  })

// 获取已保存的意向
export const getSavedIntentions = (id: number) =>
  request({
    'url': `/clientele/getIntentions/${id}`,
    'method': 'get',
  })

// 保存意向
export const saveIntentions = (data: any) =>
  request({
    'url': '/clientele/saveIntentions',
    'method': 'post',
    data
  })

// 保存意向
export const getConsultantList = () =>
  request({
    'url': '/clientele/getConsultantList',
    'method': 'get',
  })

